import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class ScoreDial extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, roundNumber)
    {
        super(scene);

        this.roundNumber = roundNumber;

        ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._round_dial, this);

        this.textLabel1 = ABCyaPhaser.Text.addText(-12, 55, 34, 0xffffff, FontKeys._odin_roundedregular, this.roundNumber, this).setOrigin(0);

        if (this.roundNumber > 0)
        {
            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 65 + 3;
            dot.y = 101 + 37 - 20;
        }


        if (this.roundNumber > 1)
        {
            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 90;
            dot.y = 101 + 40 - 20;
        }

        if (this.roundNumber > 2)
        {
            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 115 - 2;
            dot.y = 101 + 40 - 20;
        }

        if (this.roundNumber > 3)
        {
            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 139 - 4;
            dot.y = 101 + 35 - 20;
        }

        if (this.roundNumber > 4)
        {
            let dot = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._green_dot, this);
            dot.x = -99 + 162 - 4;
            dot.y = 101 + 26 - 22;
        }

        if (this.roundNumber == 1)
        {
            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 65 + 3;
            dot.y = 101 + 37 - 20;
        }

        if (this.roundNumber == 2)
        {
            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 90;
            dot.y = 101 + 40 - 20;
        }

        if (this.roundNumber == 3)
        {
            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 115 - 2;
            dot.y = 101 + 40 - 20;
        }

        if (this.roundNumber == 4)
        {
            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 139 - 4;
            dot.y = 101 + 35 - 20;
        }

        if (this.roundNumber == 5)
        {
            let dot = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._green_dot_selected, this);
            dot.x = -99 + 162 - 4;
            dot.y = 101 + 26 - 22;
        }
    }
}